"use strict";

var _classCallCheck = require("/builds/groundcontrol-app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/groundcontrol-app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTranslatorContext = exports.isTranslatorConfig = exports.TranslatorCollection = exports.PostProcessResult = void 0;
var PostProcessResult;

(function (PostProcessResult) {
  PostProcessResult[PostProcessResult["NoChange"] = 0] = "NoChange";
  PostProcessResult[PostProcessResult["RemoveNode"] = 1] = "RemoveNode";
})(PostProcessResult = exports.PostProcessResult || (exports.PostProcessResult = {})); // endregion

/* ****************************************************************************************************************** */
// region: TranslatorCollection

/* ****************************************************************************************************************** */


var TranslatorCollection = /*#__PURE__*/function () {
  function TranslatorCollection() {
    _classCallCheck(this, TranslatorCollection);
  }

  _createClass(TranslatorCollection, [{
    key: "size",
    get: function get() {
      return Object.keys(this).length;
    }
    /**
     * Add / update translator config for one or more element tags
     */

  }, {
    key: "set",
    value: function set(keys, config,
    /* @internal */
    preserveBase) {
      var _this = this;

      keys.split(',').forEach(function (el) {
        el = el.toUpperCase();
        var res = config;

        if (preserveBase) {
          var base = _this[el];
          if ((0, exports.isTranslatorConfig)(base)) res = !(0, exports.isTranslatorConfig)(config) ? Object.assign(function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return config.apply(void 0, args);
          }, {
            base: base
          }) : Object.assign(Object.assign({}, base), config);
        }

        _this[el] = res;
      });
    }
    /**
     * Get translator config for element tag
     */

  }, {
    key: "get",
    value: function get(key) {
      return this[key.toUpperCase()];
    }
    /**
     * Returns array of entries
     */

  }, {
    key: "entries",
    value: function entries() {
      return Object.entries(this);
    }
    /**
     * Remove translator config for one or more element tags
     */

  }, {
    key: "remove",
    value: function remove(keys) {
      var _this2 = this;

      keys.split(',').forEach(function (el) {
        return delete _this2[el.toUpperCase()];
      });
    }
  }]);

  return TranslatorCollection;
}();

exports.TranslatorCollection = TranslatorCollection; // endregion

/* ****************************************************************************************************************** */
// region: Utilities

/* ****************************************************************************************************************** */

/**
 * Only use to narrow union of types where only TranslatorConfig has JS type 'object'
 */

var isTranslatorConfig = function isTranslatorConfig(v) {
  return typeof v === 'object';
};

exports.isTranslatorConfig = isTranslatorConfig;

function createTranslatorContext(visitor, node, metadata, base) {
  var instance = visitor.instance,
      nodeMetadata = visitor.nodeMetadata;
  return Object.assign({
    node: node,
    options: instance.options,
    parent: node.parentNode,
    nodeMetadata: nodeMetadata,
    visitor: visitor,
    base: base
  }, metadata);
}

exports.createTranslatorContext = createTranslatorContext; // endregion